// src/components/RoddoAdSlot.tsx
import React, { useEffect } from 'react';
import { RODDO_ADMOB, getNativeAdUnitId, type RoddoAdPlacement } from '../constants/adMob';
import { initializeRoddoAdMob } from '../services/adMob';

type RoddoAdSlotProps = {
  slotId: string;
  placement?: RoddoAdPlacement;
  className?: string;
  label?: string;
};

export default function RoddoAdSlot({
  slotId,
  placement = 'baleen-bay-feed',
  className = '',
  label = 'Sponsored',
}: RoddoAdSlotProps) {
  const adUnitId = getNativeAdUnitId(placement);
  const shouldRender = Boolean(RODDO_ADMOB.enabled && RODDO_ADMOB.baleenBayNativeAdsEnabled);

  useEffect(() => {
    if (!shouldRender) return;
    void initializeRoddoAdMob();
  }, [shouldRender]);

  if (!shouldRender) return null;

  return (
    <div
      data-ad-slot-id={slotId}
      data-ad-placement={placement}
      data-ad-unit-id={adUnitId || 'not-configured'}
      aria-label="Sponsored native ad slot"
      className={[
        className,
        'roddo-native-ad-card overflow-hidden border-dashed border-black/15 dark:border-white/15',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="flex items-start gap-3">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border border-black/10 bg-white/70 text-xl shadow-[0_10px_22px_rgba(15,23,42,0.10)] dark:bg-white/10">
          🫧
        </div>

        <div className="min-w-0 flex-1 space-y-2">
          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center rounded-full border border-black/10 bg-[#ffcd64] px-2.5 py-1 text-[10px] font-black uppercase tracking-[0.14em] text-[#2d2b42] shadow-[0_8px_16px_rgba(15,23,42,0.08)]">
              {label}
            </span>
            <span className="text-[11px] font-bold uppercase tracking-[0.12em] text-[var(--community-text-secondary)]">
              Ad
            </span>
          </div>

          <div>
            <p className="text-sm font-extrabold text-[var(--community-text-primary)]">
              Partner message
            </p>
            <p className="mt-1 text-xs leading-relaxed text-[var(--community-text-secondary)]">
              This space helps support Roddo while keeping core fishing tools available.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
